import { render, staticRenderFns } from "./tenantInstruction.vue?vue&type=template&id=da299f22&scoped=true&"
import script from "./tenantInstruction.vue?vue&type=script&lang=js&"
export * from "./tenantInstruction.vue?vue&type=script&lang=js&"
import style0 from "./tenantInstruction.vue?vue&type=style&index=0&id=da299f22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da299f22",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('da299f22')) {
      api.createRecord('da299f22', component.options)
    } else {
      api.reload('da299f22', component.options)
    }
    module.hot.accept("./tenantInstruction.vue?vue&type=template&id=da299f22&scoped=true&", function () {
      api.rerender('da299f22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SystemMaintenance/components/basicConfig/tenantInstruction.vue"
export default component.exports